export default __webpack_public_path__ + "static/media/telescope-image.01aea8c1.png";